import { render, staticRenderFns } from "./rpterstdstatusmaintain.vue?vue&type=template&id=0a00f91a&"
import script from "./rpterstdstatusmaintain.vue?vue&type=script&lang=js&"
export * from "./rpterstdstatusmaintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports